import * as Sentry from '@sentry/browser'

export function ignorePluginDisabledException (err) {
  if (err.name === 'PostMessageIO:PluginDisabled') {
    // Do nothing, we know this can happen
    console.debug('Gracefully ignoring uncritical exception', err)
    return null
  } else {
    // This is not normal, rethrow error
    throw err
  }
}

export function ignoreMissingCardOrBoardException (err) {
  if (err.message.startsWith('Invalid context, missing ')) {
    // Do nothing, we know this can happen
    console.debug('Gracefully ignoring uncritical exception', err)
    return null
  } else {
    // This is not normal, rethrow error
    throw err
  }
}

export function captureException (err) {
  Sentry.captureException(err)
}
